import  React, { Component } from 'react';
import PropTypes from 'prop-types';


class Pagination extends Component {
  constructor(props) {
    super(props);
    
    this.handlePaginate = this.handlePaginate.bind(this);
  }
  
  handlePaginate(event) {
    const id = parseInt(event.target.id, 10);
    this.props.paginateFunc(id);
    window.scrollTo(0, 0);
  }

  render(){
    let goToFirst;
    let goToLast;
    let prevPage;
    let nextPage;
    const currentPage = this.props.currentPage;
    const pageCount = this.props.pageCount;

     if (currentPage === pageCount && pageCount > 1) {
      goToFirst = <a className="pagination-item" onClick={this.handlePaginate} id={1} style={{cursor: 'pointer'}}>
        <span className="back-arrows" id={1}/></a>;
      prevPage = <a className="pagination-item" onClick={this.handlePaginate} id={currentPage - 1} style={{cursor: 'pointer'}}>
        <div className="pagination-text" id={currentPage - 1}>{currentPage - 1}</div></a>;
      nextPage = '';
      goToLast = '';

    } else if (currentPage === pageCount) {
      goToFirst = '';
      prevPage = '';
      nextPage = '';
      goToLast = '';
      
    } else if(currentPage === 1){
      goToFirst = '';
      prevPage = '';
      nextPage = <a className="pagination-item" onClick={this.handlePaginate} id={currentPage + 1} style={{cursor: 'pointer'}}>
        <div className="pagination-text" id={currentPage + 1}>{currentPage + 1}</div></a>;
      goToLast = <a className="pagination-item" onClick={this.handlePaginate} id={pageCount} style={{cursor: 'pointer'}}>
        <span className="forward-arrows" id={pageCount}/></a>;

    } else {
      goToFirst = <a className="pagination-item" onClick={this.handlePaginate} id={1} style={{cursor: 'pointer'}}>
        <span className="back-arrows" id={1}/></a>;
      prevPage = <a className="pagination-item" onClick={this.handlePaginate} id={currentPage - 1} style={{cursor: 'pointer'}}>
        <div className="pagination-text" id={currentPage - 1}>{currentPage - 1}</div></a>;
      nextPage = <a className="pagination-item" onClick={this.handlePaginate} id={currentPage + 1} style={{cursor: 'pointer'}}>
        <div className="pagination-text" id={currentPage + 1}>{currentPage + 1}</div></a>;
      goToLast = <a className="pagination-item" onClick={this.handlePaginate} id={pageCount} style={{cursor: 'pointer'}}>
        <span className="forward-arrows" id={pageCount}/></a>;
    }
     
    return(
      <div className="row-pagination-solo">
        <div className="pagination">           
          {goToFirst}
          {prevPage}
          <div className="pagination-item">
            <div className="pagination-text active">
              {currentPage}
            </div>
          </div>
          {nextPage}
          {goToLast}
        </div>
      </div>);
  }
}

Pagination.propTypes = {
  paginateFunc: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired
};

// const mapStateToProps = function(state) {
//   return {
//     currentPage: state.workorders.page,
//     pageCount: state.workorders.pageCount
//   }
// };

export default Pagination;